import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import user from "../assets/img/user.jpg"
import Qaisarnawaz from "../assets/img/qaisarnawaz.jpeg"
import Nasirmansoor from "../assets/img/nasirmansoor.jpeg"




import "swiper/css";

const teamMembers = [
    {
        name: "M. Nasir Mansoor",
        designation: "President",
        image: Nasirmansoor,
    },
    {
        name: "Zahoor Ahmad",
        designation: "Vice President",
        image: user,
    },
    {
        name: "Qaisar Nawaz",
        designation: "General Secretary",
        image: Qaisarnawaz,
    },
    {
        name: "M. Awais Akram",
        designation: "Finance Secretary",
        image: user,
    },
    {
        name: "M. Javed Amir",
        designation: "Information Secretary",
        image: user,
    },
    {
        name: "Sohail Meer",
        designation: "Press Secretary",
        image: user,
    },
    {
        name: "Mohsin Nawaz",
        designation: "Office Secretary",
        image: user,
    },
];

export default function Team() {
    return (
        <div className="container-fluid py-5">
            <div className="container py-5">
                <div className="text-center mb-5">
                    <h5 className="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">
                        Our Team
                    </h5>

                    <h1 className="display-5">
                        Our Team Members
                    </h1>
                </div>

                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={30}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        576: {
                            slidesPerView: 2,
                        },
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        },
                    }}
                >
                    {teamMembers.map((member, index) => (
                        <SwiperSlide key={index}>
                            <div className="rounded team-item">
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="img-fluid w-100 rounded-top"
                                    style={{
                                        height: "300px",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                    }}
                                />

                                <div className="team-content bg-primary text-center py-3">
                                    <span className="fs-4 fw-bold text-white">
                                        {member.name}
                                    </span>

                                    <p className="mb-0 text-white">
                                        {member.designation}
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}